import Vue from 'vue'

import './registerServiceWorker'
import Config from './components/ConfigurationPage.vue'
import Home from './components/Home.vue'
import Router from 'vue-router'



Vue.use(Router);

 export default new Router({
   mode: 'history',
   routes: [
     {
       path: '/config',
       name: 'config',
       component: Config
     },
    {
        path: '/',
        name: 'home',
        component: Home
     },
   ],
 })



